module.exports = __webpack_public_path__ + "img/9788982739781.b031cf35.jpg";